import Vue from 'vue'
import { mapState } from 'vuex'

// configs
import configs from '@/config'
import QuizStatuses from '@/constants/QuizStatuses'

// utils
import utils from '@/util'

const contentSlideTypes = [
  'textSlide',
  'bulletPoints',
  'qrcode',
  'image',
  'youtube',
  'document',
  'googleSlides',
  'spinnerWheel',
]

export default (component) => Vue.component('FooterContainer', {
  data() {
    return {
      isWhiteLabelUser: false,
    }
  },
  computed: {
    ...mapState({
      slide: (state) => state.slide,
      presentation: (state) => state.presentation,
    }),
    isPoweredByShowing() {
      if (!this.presentation.id || !this.slide.id) return true

      if (this.slide.type === 'pickAnswer' && this.slide.quizStatus === QuizStatuses.QUESTION_SCREEN) return false

      if (this.slide.type === 'pickAnswer' && this.slide.quizStatus === QuizStatuses.RESULT_SCREEN) return false

      return true
    },
    isCtaShowing() {
      if (!this.presentation.id || !this.slide.id) return false

      // dont show if current slide is not last slide
      if (this.slide.id !== this.presentation.lastSlide) return false

      if (this.slide.isEndSlide) return false

      if (contentSlideTypes.includes(this.slide.type)) return true

      if (this.slide.type === 'question') return true

      if (this.slide.type === 'openEnded' && this.slide.openEndedMultipleOption) return true

      if (this.slide.type === 'wordCloud' && this.slide.openEndedMultipleOption) return true

      return false
    },
    termsURL() {
      if (this.$route.name === 'home') {
        return 'https://ahaslides.com/terms/?source=audience_home&medium=audience_app&campaign=terms'
      }
      return `https://ahaslides.com/terms/?source=presentation_${this.presentation.id}&medium=audience_app&campaign=terms&content=${utils.getSlideType(this.slide)}`
    },
    poweredByURL() {
      if (this.$route.name === 'home') {
        return 'https://ahaslides.com/?source=audience_home&medium=audience_app&campaign=powered_by'
      }
      return `https://ahaslides.com/?source=presentation_${this.presentation.id}&medium=audience_app&campaign=powered_by&content=${utils.getSlideType(this.slide)}`
    },
    footerBannerURL() {
      return `${configs.presenterUrl}/pages/register?source=presentation_${this.presentation.id}&medium=audience_app&campaign=footer_banner&content=${utils.getSlideType(this.slide)}`
    },
  },
  mounted() {
    if (window.location.host !== configs.domain) {
      this.isWhiteLabelUser = true
    }
  },
  methods: {
    trackPoweredByGAEvent() {
      if (this.$route.name === 'home') {
        utils.gaTrackEvent(
          'Audience',
          'Footer > Powered by',
          'Audience home',
        )
      } else {
        utils.gaTrackEvent(
          'Audience',
          'Footer > Powered by',
          `Presentation ID: ${this.presentation.id}, Slide type: ${utils.getSlideType(this.slide)}`,
        )
      }
    },
    trackTermsGAEvent() {
      if (this.$route.name === 'home') {
        utils.gaTrackEvent(
          'Audience',
          'Footer > Terms',
          'Audience home',
        )
      } else {
        utils.gaTrackEvent(
          'Audience',
          'Footer > Terms',
          `Presentation ID: ${this.presentation.id}, Slide type: ${utils.getSlideType(this.slide)}`,
        )
      }
    },
    handleAudienceCtaClick() {
      utils.trackGAButtonCTA(this.presentation.id, this.slide)
    },
  },
  render(createElement) {
    // do not show any footer for white lable users
    if (this.isWhiteLabelUser) return null

    return createElement(component, {
      props: {
        isCtaShowing: this.isCtaShowing,
        isPoweredByShowing: this.isPoweredByShowing,
        termsURL: this.termsURL,
        poweredByURL: this.poweredByURL,
        footerBannerURL: this.footerBannerURL,
        trackTermsGAEvent: this.trackTermsGAEvent,
        trackPoweredByGAEvent: this.trackPoweredByGAEvent,
        handleAudienceCtaClick: this.handleAudienceCtaClick,
      },
    })
  },
})
